import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private router: Router,
              private generalService: GeneralService) { }

  ngOnInit() {
  }

  goBackToHome() {
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-not-found/page-not-found.component.ts